import { COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../context/complexDocumentContext';
import { detectLanguageDynamic } from '.././utils/services/textGenerationAPI';
import { getAllLanguage } from '.././utils/services/languageApi';
import { changeLanguage } from '.././utils/services/complexDocumentsAPI';
import { ENTERPRISE_ENV } from './helper';

const detectLanguage = (CurrentDesign, blockId, documentId, methods) => {
  return new Promise(resolve => {
    let blockType;

    if (CurrentDesign === 'email') {
      blockType = 'email_block';
    } else {
      blockType = 'block';
    }
    const payload = {
      id: documentId,
      type: CurrentDesign,
      elementId: blockId,
      elementType: blockType,
      isStandalone: false,
    };
    detectLanguageDynamic(payload)
      .then(response => {
        const statusCode = response?.statusCode;
        if (statusCode === 734 || statusCode === 742) {
          methods.set({
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_LANGUAGE_DETECTED]: true,
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.LANGUAGE]: response.data,
          });
        }
        resolve(true);
      })
      .catch(error => {
        console.log({ languageDetectionError: error });
        resolve(false);
      });
  });
};

const autoDetectLanguage = async (methods, currentDesign, organisationDetails) => {
  if (isLanguageTranslationDisabled(organisationDetails)) return;
  const currentStore = methods.get();
  const currentFlows = methods.get().flows[0];
  const blockUUIDs = currentStore[currentFlows][`${currentFlows}-0`];
  for (let i = 0; i < blockUUIDs.length; i++) {
    const result = await detectLanguage(
      currentDesign,
      currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS][blockUUIDs[i]],
      currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID],
      methods,
    );
    if (result) {
      break;
    }
  }
};

const setNewLanguage = async (currentDesign, documentId, updateLanguage) => {
  const languageList = await getAllLanguage();
  const language = languageList.data.find(list => list.code === updateLanguage);

  const payload = {
    id: documentId,
    language: {
      code: language.code,
      name: language.name,
    },
    type: currentDesign,
  };

  const response = await changeLanguage(payload);
  return response;
};

export const languageUpdateHandler = async (methods, currentDesign, organisationDetails) => {
  const currentStore = methods.get();
  const templateLanguage = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.LANGUAGE];
  if (templateLanguage) return;
  
  try {
    const currentDocumentId = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID];
    const languageCode = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.NEW_LANGUAGE_CODE];
    if (languageCode) {
      const response = await setNewLanguage(currentDesign, currentDocumentId, languageCode);
      if (response.statusCode === 1930)
        methods.set({
          [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_LANGUAGE_DETECTED]: true,
          [COMPLEX_DOCUMENT_CONTEXT_KEYS.language]: languageCode,
        });
    } else {
      autoDetectLanguage(methods, currentDesign, organisationDetails);
    }
  } catch (e) {
    console.log(e);
  } finally {
    methods.set({
      [COMPLEX_DOCUMENT_CONTEXT_KEYS.NEW_LANGUAGE_CODE]: '',
      [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_DRAG_ACTION]: false
    });
  }
};

export const isLanguageTranslationDisabled = (organisationDetails) => {
  return ENTERPRISE_ENV && organisationDetails && !organisationDetails.languageTranslation;
};
